import React from 'react';
import AurECAPermissionStatus from '../../../common/aur-eca-permission-status/AurECAPermissionStatus';

const ECAPermissionStatus: React.FC = () => {
  const handleAddPermission = () => {
    console.log('Add ECA Permission button clicked');
  };

  return (
    <>
      <div>
        <h3>ECA Admin with Document Summary</h3>
        <div>
          <AurECAPermissionStatus onUpdatePermission={handleAddPermission} onAddPermission={handleAddPermission} />
        </div>
      </div>
      <div>
        <h3>ECA Admin without Document Summary</h3>
        <div>
          <AurECAPermissionStatus onUpdatePermission={handleAddPermission} onAddPermission={handleAddPermission} />
        </div>
      </div>
      <div>
        <h3>ECA Non-Admin with Document Summary</h3>
        <div>
          <AurECAPermissionStatus onUpdatePermission={handleAddPermission} onAddPermission={handleAddPermission} />
        </div>
      </div>
      <div>
        <h3>ECA Non-Admin without Document Summary</h3>
        <div>
          <AurECAPermissionStatus onUpdatePermission={handleAddPermission} onAddPermission={handleAddPermission} />
        </div>
      </div>
      <div>
        <h3>None with Document Summary</h3>
        <div>
          <AurECAPermissionStatus onUpdatePermission={handleAddPermission} onAddPermission={handleAddPermission} />
        </div>
      </div>
      <div>
        <h3>None without permisson enabled</h3>
        <div>
          <AurECAPermissionStatus onUpdatePermission={handleAddPermission} onAddPermission={handleAddPermission} />
        </div>
      </div>
    </>
  );
};

export default ECAPermissionStatus;
